/*/ ## EF.Collections.ActionPlanItemResponsesCollection
//
// Collection for action plan items
*/
(function(EF, undefined) {

    var ActionPlanItemResponsesCollection = Chaplin.Collection.extend({
    model: EF.Models.ActionPlanItemResponse,
    fileName: 'action_plan_item_responses.json',
    initialize: function(models, options) {
      this.enrollment = options.enrollment;
    },

    fetchWithParams: function(params) {
      this.params = params;
      return this.fetch();
    },

    url: function() {
      return EF.url('/sdk/enrollments/' + this.enrollment.get('id') +'/' + this.fileName + '?' + $.param(this.params || {}));
    }

  });


  _.extend(EF.Collections, {
    ActionPlanItemResponsesCollection: ActionPlanItemResponsesCollection
  });

})(EF);
